module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--de-1421b21a4dae2f79a7ca8a8cd116b9ab.webp";